export const GET_HABITS = "@habits/getHabits";
export const GET_CURRENT_HABITS = "@habits/getCurrentHabits";
